
const digest = '90f67dc0dbf7cb8da298a0d49507e25d0d964b1b56591a666fa54d41992d2bb0';
const classes = {"wrapper":"_wrapper_1b2bm_1","submitRow":"_submitRow_1b2bm_4","submitToCssz":"_submitToCssz_1b2bm_11","item":"_item_1b2bm_14"};
const css = `._wrapper_1b2bm_1 {
  font-family: Rubik, "sans-serif";
}
._wrapper_1b2bm_1 ._submitRow_1b2bm_4 {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
  margin-top: 8px;
}
._wrapper_1b2bm_1 ._submitToCssz_1b2bm_11 {
  flex-shrink: 0;
}
._wrapper_1b2bm_1 ._item_1b2bm_14 {
  font-size: 14px;
}
._wrapper_1b2bm_1 ._item_1b2bm_14 span {
  color: #9ea0a5;
  font-size: 12px;
}
._wrapper_1b2bm_1 ._item_1b2bm_14 b {
  font-weight: 600;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  